
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';
import lazyInject from '@/di';
import SPUService from '@/services/spu.service';
import { DebounceTime } from '@/common/decorator';

@Component({})
export default class IntroductionField extends Vue {
  val = '';

  oldId = 0;

  dataList: any[] = [];

  textData: any = [];

  introduction = '';

  intType = false;

  @lazyInject(SPUService)
  spuService!: SPUService;

  @Prop()
  placeholder?: string;

  @Prop()
  readonly!: boolean;

  @Prop()
  form!: any;
  @Prop()
  disabled?: boolean;

  @Prop()
  refs!: any;

  @Model('change', {
    type: String,
  })
  value!: string;

  @DebounceTime()
  @Watch('form.category')
  async watchCategory() {
    if (this.oldId !== this.form.category.id) {
      this.dataList = [];
      this.textData = [];
      if (!this.form.id) {
        const res = await this.spuService.getcategoryIdDetail(this.form.category.id);
        if (res) {
          let test = '';
          if (res.default_item) {
            test = res.default_item;
          } else if (res.p_default_item) {
            test = res.p_default_item;
          }
          this.val = test;
        }
      }
      this.oldId = this.form.category.id;
      const res = await this.spuService.postShopDetailItem({
        cid: this.form.category.id,
      });
      if (res) {
        this.dataList = res;
      }
    }
  }

  @Watch('form.id')
  watchForm() {
    console.log(this.form);
  }

  @Watch('val')
  watchInternalVal(): void {
    this.$emit('change', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  funIntType() {
    this.intType = !this.intType;
  }
  onChange(index: any, value: any) {
    value = value.join(',');
    this.fun(index, value);
  }
  handleChange(index: any, value: any) {
    this.fun(index, value);
  }
  fun(index: any, value: any) {
    const data: any = this.dataList;
    const { textData } = this;
    console.log(this.val);
    const textArr = this.val.split('\n');
    console.log(textArr, textData);
    data.forEach((item: any, i: any) => {
      if (i === index) {
        if (textData.find((rem: any) => rem.item === item.item)) {
          textData.find((rem: any) => rem.item === item.item).value = value;
        } else {
          textData.push({
            item: item.item,
            value,
          });
        }
      }
    });
    this.val = textData.map((item: any) => `●${item.item}: \n${item.value}`).join('\n\n');
  }
  mounted() {
    this.watchValue();
    this.watchCategory();
    this.oldId = 0;
    // console.log(this.form.introduction);
    this.introduction = this.form.introduction;
  }
}
